const sidebarIsOpen = state => state.sidebarIsOpen;
const getSectors = state => state.testShapes;
const getCurrentImage = state => state.currentImage;
const getSeats = state => state.testSeats;
const getCurrentSeatImage = state => state.currentSeatImage;

export default {
  sidebarIsOpen,
  getSectors,
  getCurrentImage,
  getSeats,
  getCurrentSeatImage
}